import React, {useEffect, useState, useMemo } from 'react';

import {
    Container, Row, Col,
    CardText,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from 'reactstrap';
import { connect } from 'react-redux';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Table from './table';
// import tableCustomers from './tableCustomers';
import TableVehicles from './tableVehicles';
import classnames from "classnames";
import TableCustomers from './tableCustomers';
import CC_Stats from './cc_stats';
import AIChatButton from "../../components/Common/AIChatButton";
import { formatCurrency } from '../../utils/formatCurrency';
import moment from 'moment';
moment.locale('es');




const CC = (props) => {

    const version = props.versionDB;

    document.title = "Mensuales | TicketControl - Monitor";

    const [activeTab2, setactiveTab2] = useState("1");

    const toggle2 = (tab) => {
        if (activeTab2 !== tab) {
            setactiveTab2(tab);
        }
    };

    const from_version = "1.2.49";
    function compareVersions(v1, v2) {
        try {
        
        const v1Parts = v1.split('.').map(Number);
        const v2Parts = v2.split('.').map(Number);

        for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
            const v1Part = v1Parts[i] || 0; // Si no hay más partes, se considera como 0
            const v2Part = v2Parts[i] || 0;

            if (v1Part < v2Part) {
                return true;
            }
            if (v1Part > v2Part) {
                return false;
            }
        }

        } catch (error) {
            console.error('Error al comparar versiones:', error.message);
            console.log('v1', v1);
            console.log('v2', v2);
            return false;
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="TicketControl" breadcrumbItem="Mensuales" />

                    <div className="text-muted mb-3" style={{ fontSize: 13 }}>
                        <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 20 }}>credit_card</span>
                        Gestión de clientes mensuales y sus vehículos. Consulta balances, matrículas asociadas y próximos cargos.
                    </div>

                    {!compareVersions(from_version, version) && <Table />}


                    {/* NUEVA VERSION > 1.2.50 */}
                    {compareVersions(from_version, version) &&
                    <>
                        <CC_Stats />
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab2 === "1",
                                    })}
                                    onClick={() => {
                                        toggle2("1");
                                    }}
                                >
                                    <span className="material-symbols-rounded me-1" style={{ fontSize: 18 }}>group</span>
                                    Clientes
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab2 === "2",
                                    })}
                                    onClick={() => {
                                        toggle2("2");
                                    }}
                                >
                                    <span className="material-symbols-rounded me-1" style={{ fontSize: 18 }}>directions_car</span>
                                    Vehículos
                                </NavLink>
                            </NavItem>


                        </Nav>

                        <TabContent activeTab={activeTab2} className="p-3 text-muted">
                            <TabPane tabId="1">
                                <Row>
                                    <Col sm="12">
                                        <CardText className="mb-0">
                                            <Row>
                                                <TableCustomers />
                                            </Row>
                                        </CardText>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="2">
                                <Row>
                                    <Col sm="12">
                                        <CardText className="mb-0">
                                            <Row>
                                                <TableVehicles />
                                            </Row>
                                        </CardText>
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>



                    </>}

                    {/* AI Chat */}
                    <CCAI cc={props.cc} cc_vehicles={props.cc_vehicles} />

                </Container>
            </div>
        </React.Fragment>
    );
};




// ---- AI Data Summary builder ----
const CCAI = ({ cc, cc_vehicles }) => {
    const aiDataSummary = useMemo(() => {
        if (!cc || !cc.length) return "";

        let out = `MODULO DE MENSUALES\n\n`;

        // General stats
        const totalClients = cc.filter(c => !c.timelapse_id).length;
        const totalVehicles = cc_vehicles.length;
        const totalDebt = cc.reduce((a, c) => a + (c.balance || 0), 0);
        const clientsWithDebt = cc.filter(c => c.balance < 0);
        const clientsWithCredit = cc.filter(c => c.balance > 0);

        out += `RESUMEN GENERAL:\n`;
        out += `- Total clientes: ${totalClients}\n`;
        out += `- Total vehiculos: ${totalVehicles}\n`;
        out += `- Balance total: ${formatCurrency(totalDebt)}\n`;
        out += `- Clientes con deuda: ${clientsWithDebt.length}\n`;
        out += `- Clientes con credito a favor: ${clientsWithCredit.length}\n\n`;

        // Clients with highest debt
        if (clientsWithDebt.length) {
            const sorted = [...clientsWithDebt].sort((a, b) => a.balance - b.balance);
            const top = sorted.slice(0, 10);
            out += `CLIENTES CON MAYOR DEUDA:\n`;
            top.forEach(c => {
                out += `- ${c.fullName}: ${formatCurrency(c.balance)} (${c.vehicle_count} vehiculo/s)\n`;
            });
            out += "\n";
        }

        // By category
        const byCategory = {};
        cc_vehicles.forEach(v => {
            const cat = v.category_name || "Sin categoria";
            if (!byCategory[cat]) byCategory[cat] = { count: 0, totalValue: 0 };
            byCategory[cat].count++;
            byCategory[cat].totalValue += v.custom_value > 0 ? v.custom_value : (v.rate_value || 0);
        });
        if (Object.keys(byCategory).length > 0) {
            out += `VEHICULOS POR CATEGORIA:\n`;
            Object.entries(byCategory).sort((a, b) => b[1].count - a[1].count).forEach(([k, v]) => {
                out += `- ${k}: ${v.count} vehiculos, facturacion mensual ${formatCurrency(v.totalValue)}\n`;
            });
            out += "\n";
        }

        // Monthly revenue (sum of all vehicle rates)
        const totalMonthlyRevenue = cc_vehicles.reduce((a, v) => {
            return a + (v.custom_value > 0 ? v.custom_value : (v.rate_value || 0));
        }, 0);
        const customRateVehicles = cc_vehicles.filter(v => v.custom_value > 0);
        out += `FACTURACION MENSUAL ESTIMADA:\n`;
        out += `- Total: ${formatCurrency(totalMonthlyRevenue)}\n`;
        out += `- Promedio por vehiculo: ${formatCurrency(totalVehicles > 0 ? totalMonthlyRevenue / totalVehicles : 0)}\n`;
        if (customRateVehicles.length) {
            out += `- Vehiculos con tarifa especial: ${customRateVehicles.length}\n`;
        }
        out += "\n";

        // Upcoming charges
        const upcoming = cc.filter(c => c.next_movement).sort((a, b) => {
            return new Date(a.next_movement) - new Date(b.next_movement);
        });
        if (upcoming.length) {
            const next7Days = upcoming.filter(c => {
                const d = new Date(c.next_movement);
                const now = new Date();
                const diff = (d - now) / (1000 * 60 * 60 * 24);
                return diff >= 0 && diff <= 7;
            });
            if (next7Days.length) {
                out += `PROXIMOS CARGOS (7 dias):\n`;
                next7Days.forEach(c => {
                    out += `- ${c.fullName}: ${moment(c.next_movement).format("DD/MM/YYYY")} (balance: ${formatCurrency(c.balance)})\n`;
                });
                out += "\n";
            }
        }

        // Vehicles without plate
        const noPlate = cc_vehicles.filter(v => !v.plate);
        if (noPlate.length) {
            out += `VEHICULOS SIN MATRICULA: ${noPlate.length}\n\n`;
        }

        return out;
    }, [cc, cc_vehicles]);

    const aiSuggestions = useMemo(() => [
        "¿Cuantos clientes y vehiculos hay?",
        "¿Cual es la deuda total?",
        "¿Quienes deben mas?",
        "¿Cuanto se factura por mes?",
        "¿Que cargos hay proximos?",
        "¿Como se distribuyen por categoria?",
    ], []);

    if (!aiDataSummary) return null;
    return (
        <AIChatButton
            context="cc"
            dataSummary={aiDataSummary}
            suggestions={aiSuggestions}
            title="Asistente Mensuales"
        />
    );
};

const mapStateToProps = (state) => {
    return {
        versionDB: state.data.versionDB,
        cc: state.data.cc,
        cc_vehicles: state.data.cc_vehicles,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CC);



// export default CC;


